import { PulseBetPeriod } from "../../ViewModel";
import { observable } from "mobx";

export type PulseBetMarketAdditionalDataType = {
    name: string;
    durationInMilli: number;
    marketId: string;
    branchID: string;
    typeId? : string;
    currencySign: string;
    periods: PulseBetPeriod[];
    isDanger: boolean;
}

export class PulseBetMarketAdditionalData {

    name: string;
    durationInMilli: number;
    marketId: string;
    branchID: string;
    typeId : string;
    currencySign: string;
    @observable periods: PulseBetPeriod[];
    @observable isDanger: boolean;

    constructor(source: PulseBetMarketAdditionalDataType) {
        this.name = source.name;
        this.durationInMilli = source.durationInMilli;
        this.marketId = source.marketId;
        this.currencySign = source.currencySign;
        this.periods = source.periods;
        this.branchID = source.branchID;
        this.typeId = source.typeId || "0";
        this.isDanger = source.isDanger;
    }
}